import { useTranslation } from 'react-i18next'
import { ReactSVG } from 'react-svg'
import { useMediaQuery } from 'usehooks-ts'

import { useAddressStore } from '@features/shipping-methods'

import useDeliveryModal from '@widgets/modal-delivery/ui/useDeliveryModal'
import { useSlots, useSlotStore } from '@widgets/slots'


import { useZonesFromAddress } from '@shared/hooks/useZonesFromAddress'
import { cn } from '@shared/lib/cn'
import { formatPrice } from '@shared/uttils'

import styles from './styles.module.scss'

interface DeliveryInfoProps {
  className?: string;
}

export default function DeliveryInfo (props: DeliveryInfoProps) {
  const { className } = props
  const { t: tc } = useTranslation('common')
  const { t: to } = useTranslation('order')
  const isTablet = useMediaQuery('(max-width: 767px)')
  const { selectedSlot } = useSlotStore()
  const { openSlotsModal } = useSlots()

  const { openDeliveryModal } = useDeliveryModal()
  const {
    isPickup,
    deliveryCost,
  } = useZonesFromAddress()
  const { selectedAddress } = useAddressStore()

  return (
    <div className={cn(styles.root, className)}>
      <div
        className={styles.address}
        onClick={() => {
          openDeliveryModal()
        }}
      >
        <img
          src="/icons/map-pin.svg"
          alt=""
          loading="lazy"
          fetchPriority="low"
        />
        <span>
          {selectedAddress
            ? selectedAddress?.address?.length &&
              selectedAddress?.address?.length > 35
              ? selectedAddress?.address?.slice(0, 35) + '...'
              : selectedAddress.address
            : tc(!isTablet ? 'touch-delivery' : 'touch-delivery-mob')}
        </span>
        <ReactSVG src="/icons/arrow-right.svg" />
      </div>

      <div
        onClick={() => {
          if (selectedAddress) {
            openSlotsModal()
          }
        }}
        className={styles.time}
      >
        {selectedSlot && (
          <span className={styles.time__value}>
            {!isPickup() ? (
              <>
                {selectedSlot.slotDate} c{' '}
                {selectedSlot.slotTime
                  ?.split(' - ')
                  .map((time) => time.split(':')[0])
                  .join(to('up_to'))}
              </>
            ) : (
              tc('pickup')
            )}
          </span>
        )}
        {selectedAddress && selectedSlot ? (
          <span className={styles.price}>
            {isPickup() ? (
              <>
                {selectedSlot.slotDate} c{' '}
                {selectedSlot.slotTime
                  ?.split(' - ')
                  .map((time) => time.split(':')[0])
                  .join(to('up_to'))}
              </>
            ) : !deliveryCost ? (
              to('free_delivery')
            ) : (
              `${tc('delivery')} 0 - ${formatPrice(deliveryCost)}`
            )}
            {isTablet && <ReactSVG src="/icons/arrow-right.svg" />}
          </span>
        ) : null}
      </div>
    </div>
  )
}
